
import {Options} from 'vue-class-component';
import {Prop} from "vue-property-decorator";
import {ElasticSearchSearchService, Search, SearchServiceResponse} from "@/interfaces/search.ts";
import FinderSearchBar from "@/components/FinderSearchBar.vue";
import SearchResults from '@/components/SearchResults.vue';
import SearchIcon from '@/assets/icons/icons-search.svg?inline';
import CloseIcon from '@/assets/icons/icons-close.svg?inline';
import Finder from '@/components/Finder.ts';

@Options({
  components: {
    SearchResults,
    FinderSearchBar,
    SearchIcon,
    CloseIcon,
  }
})

export default class SearchFinder extends Finder<SearchServiceResponse, ElasticSearchSearchService, Search> {
  @Prop({default: ''}) private noResultTitle?: string | null;
  @Prop({default: ''}) private noResultAbstract?: string | null;
  @Prop({default: ''}) private noResultLink?: string | null;
  @Prop({default: ''}) private finderTitle?: string | null;

  protected endpoint: string = `${_mgnl.contextPath}/.rest/search/v1/search/website`;

  protected setup() {
    super.setup();
  }
}
